import { PACKAGE_STATUS, DIRECT_ORDER_STATUS, GROUP_ORDER_STATUS } from './constants';
import { Package, OrderStatus } from './types';

export const getPackageStatus = (pkg: Package) => {
  let text: string | undefined;
  let color: string | undefined;
  if (pkg?.order?.id) {
    if (pkg.shippingGroup) {
      text = GROUP_ORDER_STATUS[pkg?.subOrder?.status ?? pkg.order.status].text;
      color = GROUP_ORDER_STATUS[pkg?.subOrder?.status ?? pkg.order.status].color;
    } else if (pkg.order.country === 'CN' && pkg.order.status === OrderStatus.Shipped) {
      text = '已转寄国内';
      color = 'default';
    } else {
      text = DIRECT_ORDER_STATUS[pkg.order.status]?.text;
      color = DIRECT_ORDER_STATUS[pkg.order.status]?.color;
    }
  } else if (pkg.status) {
    color = PACKAGE_STATUS[pkg.status].color;
    text = PACKAGE_STATUS[pkg.status].text;
  }
  return { text, color };
};

export const canUpdateOrderAddress = (order): boolean => {
  switch (order.status) {
    case OrderStatus.Created:
    case OrderStatus.Packing:
    case OrderStatus.Packed:
    case OrderStatus.Shipped:
    case OrderStatus.Problem:
      return true;
    default:
      return false;
  }
};

export const canConfirmReceived = (order): boolean => {
  if (!order.shippingGroup) {
    // direct order
    return order.status === OrderStatus.Shipped;
    // } else if (order.parentOrder) {
    //   // group sub order
    //   return order.status === OrderStatus.PickupPending;
  } else {
    // group main order
    return order.status === OrderStatus.Shipped || order.status === OrderStatus.PickupPending;
  }
};

export const isGroupSubOrder = (order): boolean => {
  return order.shippingGroup && order.parentOrder;
};

export const isDirectOrder = (order): boolean => {
  return !order.shippingGroup;
};

export const isGroupMainOrder = (order): boolean => {
  return order.shippingGroup && !order.parentOrder;
};
